import { render, staticRenderFns } from "./alert-toast-danger.vue?vue&type=template&id=0aba7fb7&"
import script from "./alert-toast-danger.vue?vue&type=script&lang=js&"
export * from "./alert-toast-danger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports